var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},_vm._l((_vm.drillModulesByClassCategoryCode),function(drillModule){return _c(drillModule,{tag:"component",attrs:{"isReport":_vm.isReport}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }